<div id="holding" class="bg">
  <div class="container">
    <div class="row justify-content-center align-items-center centerize">
      <div class="col-xl-5 col-md-8 col-sm-10">
        <div class="form-inner">
          <div class="logo">
            <img src="assets/img/kalem-logo2-png.png" class="kalemlogo" />
            <div class="form-title baslik">Şifre Sıfırlama</div>
          </div>
          <small [hidden]="token || successStatus"
            >Şifrenizi sıfırlamak için kullandığınız KLMERP kullanıcı adınızı
            giriniz. Şifreni sıfırlamak için kullanacağınız bağlantıyı içeren
            bir e-posta gönderilecektir.
          </small>
          <small [hidden]="!token || successStatus"
            >Şifreyi sıfırlamak için aşağıdaki bilgileri girerek Şifreyi
            Sıfırla'ya tıklayınız.</small
          >
          <div class="mt-2" *ngIf="!successStatus">
            <div>
              <form *ngIf="!token" #usernameForm="ngForm" novalidate>
                <div class="form-group row mt-4">
                  <label for="username">{{ "username" | translate }}</label>
                  <input
                    type="text"
                    name="username"
                    id="username"
                    [(ngModel)]="user.username"
                    #userName="ngModel"
                    class="form-control form-control-sm"
                    [ngClass]="
                      errorStatus && userName.invalid ? 'errorInput' : ''
                    "
                    required
                  />
                  <div
                    *ngIf="userName.invalid && errorStatus"
                    class="errorMessage"
                  >
                    {{ "important_area" | translate }}
                  </div>
                  <button
                    class="btn btn-block w-100 btn-kalemblue"
                    (click)="
                      usernameForm.invalid
                        ? (errorStatus = true)
                        : onSubmit('forgot')
                    "
                  >
                    {{ "reset_my_password" | translate }}
                  </button>
                </div>
                <div class="reset-password-alert">
                  <kl-alert
                    [message]="alertMessage"
                    type="error"
                    [show]="alertShow"
                    (onClose)="alertShow = false"
                  ></kl-alert>
                </div>
              </form>
              <form *ngIf="token" (ngSubmit)="onSubmit('reset')" novalidate>
                <div class="form-group row">
                  <label for="password">{{ "new_password" | translate }}</label>
                  <input
                    type="password"
                    name="password"
                    [(ngModel)]="reset.password"
                    class="form-control form-control-sm"
                    id="password"
                  />
                </div>
                <div class="form-group row">
                  <label for="rePassword">{{
                    "new_password_confirmation" | translate
                  }}</label>
                  <input
                    type="password"
                    name="repassword"
                    [(ngModel)]="reset.confirm_password"
                    class="form-control form-control-sm"
                    id="rePassword"
                  />
                  <button class="btn btn-kalemblue btn-block w-100">
                    {{ "reset_password" | translate }}
                  </button>
                </div>
                <div
                  class="alert alert-danger"
                  role="alert"
                  [hidden]="!errorStatus"
                >
                  {{ "password_reset_error" | translate }}
                </div>
                <div
                  class="alert alert-warning"
                  role="alert"
                  [hidden]="!passwordStatus"
                >
                  {{ "password_not_same" | translate }}
                </div>
              </form>
            </div>
          </div>
          <div class="col-md-12" *ngIf="successStatus">
            <div *ngIf="!token" class="row">
              <div class="success-message message">
                {{ "send_reset_link_success_message" | translate }}
              </div>
              <a
                role="button"
                [routerLink]="['/auth/login']"
                class="btn btn-block btn-kalemblue m-k"
                >Kullanıcı Giriş Sayfasına Git</a
              >
            </div>
            <div *ngIf="token" class="row">
              <div class="success-message message">
                {{ "reset_password_success_message" | translate }}
              </div>
              <a
                role="button"
                [routerLink]="['/auth/login']"
                class="btn btn-block btn-kalemblue m-k"
                >Kullanıcı Giriş Sayfasına Git</a
              >
            </div>
          </div>
          <small
            >Başka konularda yardım isterseniz
            <a href="auth/login" class="lnk">KLMERP Destek</a> ile iletişime
            geçebilirsiniz.</small
          >
        </div>
      </div>
    </div>
  </div>
</div>
